import * as React from "react";
import {Component} from "react";
import styles from "../styles/wizards/AddRoomGroupWizard.scss";
import autobind from "autobind-decorator";
import AddRoomGroupIcon from "../assets/images/add-room-group-64x64.svg";
import {__, mapStateToProps, setTableParams, validateForm} from "../core/utils";
import {withRouter} from "react-router";
import {getStagesLanguages} from "../redux/actions/table/stages";
import {setNotification} from "../redux/actions/general/notification";
import {createRoomGroup, listRoomGroups} from "../redux/actions/table/room_groups";
import AddRoomGroupForm from "../forms/add_room_group_wizard/AddRoomGroupForm";

@withRouter
@mapStateToProps(state => ({
	table: state.table["room_groups"],
}))
class AddRoomGroupWizard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			project_languages: null
		}
	}

	componentDidMount() {
		getStagesLanguages(this.props.match.params.stage).then(({response}) => {
			this.setState({project_languages: response.data});
		});
	}

	@autobind
	_handleSubmit(formData) {
		const {edit} = formData;

		formData = _.omit(formData, ['edit']);

		return validateForm(
			createRoomGroup(this.props.match.params.stage, formData).then(({response}) => {
				listRoomGroups(this.props.match.params.stage).then(() => {
					if(edit) {
						setTableParams('room_groups', {
							clicked_row: response.data.id
						});
					}
				});

				setTableParams('room_groups', {
					actioned_row: undefined,
					selected_rows: []
				});

				this.props.onClose();

				setNotification(__("wizard.add-room-group.message.success"));
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>{__('wizard.add-room-group.title.add-new-room-group')}</span>
						<span>{__('wizard.add-room-group.subtitle.add-new-room-group')}</span>
					</div>
					<div className={styles.right}>
						<AddRoomGroupIcon />
					</div>
				</div>
				<div className={styles.body}>
					{this.state.project_languages && <AddRoomGroupForm
						projectLanguages={this.state.project_languages}
						onSubmit={this._handleSubmit}
						initialValues={{
							title: {},
							description: {},
						}}
					/>}
				</div>
			</>
		);
	}
}

export default AddRoomGroupWizard;